import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';

export default class ColoredScrollbars extends Component {

    constructor(props, ...rest) {
        super(props, ...rest);
        this.state = { 
          top: 0,
          scrollbarStyles: {
            width: 8,
            borderRadius:100,
          } 
        };
        this.renderView = this.renderView.bind(this);
        this.renderThumb = this.renderThumb.bind(this);

    }

    renderView({ style, ...props }) {
        const { top } = this.state;
        const viewStyle = {
        };
        return (
            <div
                className="box"
                style={{ ...style, ...viewStyle }}
                {...props}/>
        );
    }

    renderThumb({ style, ...props }) {
        const { scrollbarStyles } = this.state;
        return (
            <div
                className="scrollbar-y"
                style={{ ...style, ...scrollbarStyles }}
                {...props}/>
        );
    }

    render() {
        return (
            <Scrollbars 
                renderView={this.renderView}
                renderThumbVertical={this.renderThumb}
                {...this.props}/>
        );
    }
}


// WEBPACK FOOTER //
// ./src/widget/components/customScrollbars/CustomScrollbars.js